import React from "react";
import { Link } from "react-router-dom";
//import industrialPeopleImg from "../images/hydrotec-industrial-people.png"; // replace with your image path
import { assets } from "../data/siteData";
import "./PurposeSection.css"; // Import the CSS file for styling
export default function PurposeSection() {
  return (
    <section className="purpose-section">
      <div className="purpose-media">
        <img src={assets.stand} alt="Hydrotec industrial team" />
      </div>

      <div className="purpose-content">
        <div className="purpose-inner">
          <p className="purpose-eyebrow">Who we are</p>
          <h2>
            Engineering water systems
            <span> that endure</span>
          </h2>
          <p>
            Hydrotec Solutions delivers reliable water infrastructure with a
            strong focus on treatment performance, operational visibility, and
            long-term sustainability. We combine practical engineering,
            intelligent monitoring, and field-ready execution to support
            communities, institutions, and industrial projects with confidence.
          </p>

          <Link to="/about" className="purpose-btn">
            Learn more
          </Link>
        </div>
      </div>
    </section>
  );
}